/**
 * Created by spok on 16/10/18.
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../authentication/authentication.service';


@Injectable({
  providedIn: 'root',
})
export class LoggedInAuthGuard {

  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //        this.authService.logout();
    this.authService.testIsAuthenticated();
    if (this.authService.isAuthenticated()) {
      const supervisorMode = localStorage.getItem('account');
      let accountInfo;

      if (supervisorMode) {
        accountInfo = JSON.parse(supervisorMode);
      }

      const isSuperUser = accountInfo ? accountInfo.isSuperUser : false;

      if (isSuperUser) {
        this.router.navigate(['/dashboard']);
        return false;
      }

      if (!isSuperUser) {
        this.router.navigate(['/home']);
        return false;
      }
    } else {
      return true;
    }
  }
}
